<div class="container-fluid" *ngIf="item">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Discounts Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item"><a routerLink="/ecomm/discounts">Discounts</a></li>
            <li class="breadcrumb-item active">{{ isEditMode ? 'Edit' : 'View' }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{ isEditMode ? 'Edit Discount' : 'Discount Details' }}</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/discounts" class="btn btn-light me-2">Back to List</a>
            <ng-container *ngIf="!isEditMode">
              <button type="button" class="btn btn-primary" (click)="startEdit()">Edit</button>
            </ng-container>
            <ng-container *ngIf="isEditMode">
              <button type="button" class="btn btn-light me-2" (click)="cancelEdit()">Back</button>
              <button type="button" class="btn btn-primary" (click)="save()">Save</button>
            </ng-container>
          </div>
        </div>
        <div class="card-body">
          <div class="row gy-4" *ngIf="!isEditMode">
            <div class="col-xxl-6 col-md-6"><label class="form-label">ID</label><input class="form-control" [value]="item.id" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Name</label><input class="form-control" [value]="item.name" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Discount Type</label><input class="form-control" [value]="discountTypeLabel(item.discount_type)" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Discount Value</label><input class="form-control" [value]="item.discount_value" readonly></div>
            <div class="col-xxl-6 col-md-6"><label class="form-label">Status</label><input class="form-control" [value]="statusLabel(item.status)" readonly></div>
          </div>

          <div class="row gy-4" *ngIf="isEditMode">
            <div class="col-xxl-6 col-md-6"><label class="form-label">ID</label><input class="form-control" [value]="item.id" readonly></div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Name <span class="text-danger">*</span></label>
              <input class="form-control" name="name" [(ngModel)]="form.name" [ngClass]="{'is-invalid': !form.name && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Discount Type <span class="text-danger">*</span></label>
              <select class="form-select" name="discount_type" [(ngModel)]="form.discount_type">
                <option [ngValue]="1">Amount</option>
                <option [ngValue]="2">Percentage</option>
              </select>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Discount Value <span class="text-danger">*</span></label>
              <input type="number" step="0.01" class="form-control" name="discount_value" [(ngModel)]="form.discount_value"
                     [ngClass]="{'is-invalid': (form.discount_value === '' || form.discount_value === null) && validationTriggered}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label">Status <span class="text-danger">*</span></label>
              <select class="form-select" name="status" [(ngModel)]="form.status">
                <option [ngValue]="1">Active</option>
                <option [ngValue]="2">Inactive</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
